import { Injectable } from '@angular/core';
import { ApiClientService } from '@tablesready/api-client';
import { Observable } from 'rxjs';
import { AccountUser, LocationUser, User } from '@shared/user/models';
import {
  ApplyCouponRequest,
  EditAccountUserRequest,
  Privacy,
  UpdateAccountRequest, UpdateBillingInfoRequest, UpdateRecurlyAccountInfoRequest,
} from '@shared/account/models';
import { Location } from '@shared/location/models';
import { Invite } from '@shared/invite/models';

@Injectable({providedIn: 'root'})
export class AccountApiService {
  private readonly basePath = '/v.1/account';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.basePath}/users`);
  }

  update(data: UpdateAccountRequest): Observable<void> {
    return this.http.put<void>(this.basePath, data);
  }

  updateAccountUser(accountUserId: string, data: EditAccountUserRequest): Observable<void> {
    return this.http.patch<void>(`${this.basePath}/account-users/${accountUserId}`, data);
  }

  updatePrivacySettings(data: Privacy): Observable<void> {
    return this.http.put<any>(`${this.basePath}/privacy`, data);
  }

  updateBillingInfo(data: UpdateBillingInfoRequest): Observable<void> {
    return this.http.post<void>(`${this.basePath}/billing`, data);
  }

  updateRecurlyAccountInfo(data: UpdateRecurlyAccountInfoRequest): Observable<void> {
    return this.http.post<void>(`${this.basePath}/recurlyAccountInfo`, data);
  }

  applyCoupon(data: ApplyCouponRequest): Observable<void> {
    return this.http.post<void>(`${this.basePath}/coupon`, data);
  }

  removeFromLocation(locationId: string, locationUserId: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/${locationId}/location-users/${locationUserId}`);
  }

  removeAccountUser(accountUserId: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/account-users/${accountUserId}`);
  }

  getLocations(): Observable<Location[]> {
    return this.http.get<Location[]>(`${this.basePath}/locations`);
  }

  getLocationUsers(): Observable<LocationUser[]> {
    return this.http.get<LocationUser[]>(`${this.basePath}/location-users`);
  }

  getAccountUsers(): Observable<AccountUser[]> {
    return this.http.get<AccountUser[]>(`${this.basePath}/account-users`);
  }

  getInvites(): Observable<Invite[]> {
    return this.http.get<Invite[]>(`${this.basePath}/invites`);
  }

  deleteAccount(): Observable<void> {
    return this.http.delete<void>(`${this.basePath}`);
  }

  resetWebsiteUrl(): Observable<void> {
    return this.http.post<void>(`${this.basePath}/reset-website-url`, {});
  }
}
